var map = {
	"./base/baseIndex.vue": [
		"5057",
		"chunk-24bb9448"
	],
	"./base/baseMange.vue": [
		"aaa6",
		"chunk-2d21310b"
	],
	"./base/baseadmission.vue": [
		"3454",
		"chunk-1607c43e"
	],
	"./campus/Administration.vue": [
		"dce9",
		"chunk-19110ccc"
	],
	"./campus/CampusManage.vue": [
		"0e53",
		"chunk-2d0af489"
	],
	"./campus/activity.vue": [
		"94e9",
		"chunk-d07b141c",
		"chunk-38036c0f"
	],
	"./campus/activityManage.vue": [
		"5684",
		"chunk-2d0c8a53"
	],
	"./campus/activityMenber.vue": [
		"187a",
		"chunk-2bdcb628"
	],
	"./campus/classification.vue": [
		"4d07",
		"chunk-7398113f"
	],
	"./campus/course/courseIndex.vue": [
		"5017",
		"chunk-8e031990"
	],
	"./campus/course/courseManage.vue": [
		"206b",
		"chunk-2d0b16a0"
	],
	"./campus/course/editIndex.vue": [
		"92f0",
		"chunk-50e53200"
	],
	"./campus/editItem.vue": [
		"5577",
		"chunk-654b8cdc"
	],
	"./campus/maintain.vue": [
		"4e99",
		"chunk-d07b141c",
		"chunk-6a4f59fa"
	],
	"./campus/matchAdministration.vue": [
		"60de",
		"chunk-af4913c4"
	],
	"./campus/matchList.vue": [
		"7af8",
		"chunk-26ad96ff"
	],
	"./campus/matchTrains.vue": [
		"8af2",
		"chunk-d07b141c",
		"chunk-7f6f946b"
	],
	"./campus/sponsor.vue": [
		"4d95",
		"chunk-39258905"
	],
	"./campus/trainingCamp/campEditItem.vue": [
		"f2bd",
		"chunk-395474ac"
	],
	"./campus/trainingCamp/campSponsor.vue": [
		"d2fc",
		"chunk-6881d3ed"
	],
	"./campus/trainingCamp/trainingCamp.vue": [
		"c8c9",
		"chunk-d07b141c",
		"chunk-c87e0e7a"
	],
	"./campus/trainingCamp/trainingCampMember.vue": [
		"0687",
		"chunk-77885386"
	],
	"./class/ClassList.vue": [
		"4bfe",
		"chunk-4a3c30d1"
	],
	"./class/ClassManage.vue": [
		"aa9b",
		"chunk-2d212c5f"
	],
	"./class/TheClassRoster.vue": [
		"d45d",
		"chunk-1e5fde56"
	],
	"./community/communityMange.vue": [
		"9976",
		"chunk-7a65eca9"
	],
	"./community/examine.vue": [
		"cd09",
		"chunk-6f58b891"
	],
	"./community/release.vue": [
		"f1ea",
		"chunk-1a9dff58"
	],
	"./fund/fundList.vue": [
		"3efd",
		"chunk-d07b141c",
		"chunk-314b3aa0"
	],
	"./fund/fundMange.vue": [
		"a7bf",
		"chunk-2d2093b0"
	],
	"./fund/fundMember.vue": [
		"cc25",
		"chunk-523eddb0"
	],
	"./fund/outsideServe.vue": [
		"a889",
		"chunk-516a8721"
	],
	"./home/index.vue": [
		"7abe",
		"chunk-39341828"
	],
	"./layout/AuxiliaryHeader.vue": [
		"b5d5"
	],
	"./layout/AuxiliaryLayout.vue": [
		"fac7"
	],
	"./layout/DefaultHeader.vue": [
		"6eaa"
	],
	"./layout/DefaultLayout.vue": [
		"3799"
	],
	"./layout/DefaultSidebar.vue": [
		"1983"
	],
	"./layout/Page404.vue": [
		"ceb3"
	],
	"./login/Login.vue": [
		"ede4"
	],
	"./login/LoginHeader.vue": [
		"7d2e"
	],
	"./login/SignIn.vue": [
		"7df9"
	],
	"./match/matchAdministrationN.vue": [
		"5030",
		"chunk-7d9df5c2"
	],
	"./match/matchMange.vue": [
		"42e6",
		"chunk-2d0c0c65"
	],
	"./match/perfectMatch.vue": [
		"1e95",
		"chunk-92f81c68"
	],
	"./match/prizeData.vue": [
		"7147",
		"chunk-66d074a1"
	],
	"./news/ai.vue": [
		"7f53",
		"chunk-6eb1c345"
	],
	"./news/editNews.vue": [
		"7043",
		"chunk-d07b141c",
		"chunk-24170231"
	],
	"./news/newsManage.vue": [
		"d818",
		"chunk-2d21ee71"
	],
	"./news/newsPush.vue": [
		"2d59",
		"chunk-b31702ac"
	],
	"./news/newsRelease.vue": [
		"d70f",
		"chunk-11d051d8"
	],
	"./users/userAdministration.vue": [
		"22a7",
		"chunk-50161915"
	],
	"./users/userManage.vue": [
		"695c",
		"chunk-2d0d09c7"
	],
	"./verification/ModifyBasicGrades.vue": [
		"4910"
	],
	"./verification/ModifyFeedback.vue": [
		"93a3"
	],
	"./verification/ModifyGrade.vue": [
		"0299"
	],
	"./verification/ModifyQuizGrades.vue": [
		"13f5"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;